import { Component, lazy, Suspense, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "./components/SmoothScroll";
import Preloader from "./components/Preloader";
import Skeleton from "./components/Skeleton";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";

const Tokenomics = lazy(() => import("./components/Tokenomics"));
const ChartSection = lazy(() => import("./components/ChartSection"));
const HowToBuy = lazy(() => import("./components/HowToBuy"));
const ContractSection = lazy(() => import("./components/ContractSection"));
const Roadmap = lazy(() => import("./components/Roadmap"));
const Community = lazy(() => import("./components/Community"));
const Footer = lazy(() => import("./components/Footer"));
const RewardsPage = lazy(() => import("./pages/RewardsPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const GamePage = lazy(() => import("./pages/GamePage"));

const Chunk = ({ children }) => (
    <Suspense fallback={<Skeleton />}>{children}</Suspense>
);

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-blast-bg font-mono text-sm tracking-widest text-white">
                    SOMETHING BROKE — RELOAD THE PAGE
                </div>
            );
        }
        return this.props.children;
    }
}

function Home() {
    const [showLoader, setShowLoader] = useState(true);

    return (
        <SmoothScroll>
            <div className="relative min-h-screen overflow-x-clip bg-blast-bg text-white">
                <div className="grain" aria-hidden="true" />
                {showLoader && <Preloader onGone={() => setShowLoader(false)} />}
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <Chunk>
                        <Tokenomics />
                        <ChartSection />
                        <HowToBuy />
                        <ContractSection />
                        <Roadmap />
                        <Community />
                    </Chunk>
                </main>
                <Chunk>
                    <Footer />
                </Chunk>
            </div>
        </SmoothScroll>
    );
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/rewards" element={<RewardsPage />} />
                    <Route path="/game" element={<GamePage />} />
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
